import {invalidateOnSuccess, omneticApi} from '@dms/api/base';

import {
  CalculatePkwEnvkvApiArg,
  CalculatePkwEnvkvApiResponse,
  GetPkwEnvkvStatusApiArg,
  GetPkwEnvkvStatusApiResponse,
  GeneratePkwEnvkvDocumentApiArg,
  GeneratePkwEnvkvDocumentApiResponse,
  PkwEnvkvStatusResponseBodySchema,
} from './types';

export const pkwEnvkvApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getPkwEnvkvStatus: build.query<GetPkwEnvkvStatusApiResponse, GetPkwEnvkvStatusApiArg>({
      query: ({vehicleId}) => ({
        url: `/dms/v1/vehicle/${vehicleId}/pkw-envkv/status`,
      }),
      providesTags: (result, error, {vehicleId}) => [{type: 'PkwEnvkvStatus', id: vehicleId}],
      extraOptions: {
        responseSchema: PkwEnvkvStatusResponseBodySchema,
      },
    }),
    // A preflight must not join a status query started before the advertising action.
    checkPkwEnvkvAdvertisingStatus: build.mutation<
      GetPkwEnvkvStatusApiResponse,
      GetPkwEnvkvStatusApiArg
    >({
      query: ({vehicleId}) => ({
        url: `/dms/v1/vehicle/${vehicleId}/pkw-envkv/status`,
        method: 'GET',
      }),
      extraOptions: {
        responseSchema: PkwEnvkvStatusResponseBodySchema,
      },
    }),
    calculatePkwEnvkv: build.mutation<CalculatePkwEnvkvApiResponse, CalculatePkwEnvkvApiArg>({
      query: ({vehicleId}) => ({
        url: `/dms/v1/vehicle/${vehicleId}/pkw-envkv/calculate`,
        method: 'POST',
      }),
      invalidatesTags: invalidateOnSuccess((result, {vehicleId}: CalculatePkwEnvkvApiArg) => [
        {type: 'PkwEnvkvStatus', id: vehicleId},
      ]),
    }),
    generatePkwEnvkvDocument: build.mutation<
      GeneratePkwEnvkvDocumentApiResponse,
      GeneratePkwEnvkvDocumentApiArg
    >({
      query: ({vehicleId}) => ({
        url: `/dms/v1/vehicle/${vehicleId}/pkw-envkv/generate`,
        method: 'POST',
      }),
      invalidatesTags: invalidateOnSuccess(
        (result, {vehicleId}: GeneratePkwEnvkvDocumentApiArg) => [
          {type: 'PkwEnvkvStatus', id: vehicleId},
          {type: 'documentsCount', id: vehicleId},
        ]
      ),
    }),
  }),
  overrideExisting: false,
});

export const {
  useCalculatePkwEnvkvMutation,
  useCheckPkwEnvkvAdvertisingStatusMutation,
  useGeneratePkwEnvkvDocumentMutation,
  useGetPkwEnvkvStatusQuery,
  useLazyGetPkwEnvkvStatusQuery,
} = pkwEnvkvApi;
